import { render, staticRenderFns } from "./MultiCheckboxField.vue?vue&type=template&id=39f4404e"
import script from "./MultiCheckboxField.vue?vue&type=script&lang=js"
export * from "./MultiCheckboxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports